import { Pipe, PipeTransform } from '@angular/core';
import {formatBytes} from "../utils/bytes";

@Pipe({ name: 'filesize', pure: true })
export class FilesizePipe implements PipeTransform {

  transform(value: number): unknown {
    return formatBytes(value);
  }

}
